module.exports = __webpack_public_path__ + "static/media/schody22 - schody drewniane lakierowane z podestem.237ae05b.jpg";